export const farmsAccessError = new Error(
  "Attempted to access farms data but it is not available",
);
